export default __webpack_public_path__ + "static/media/warning--dangerous-crosswinds-right--g3.74a9268a.png";